import { useState } from 'react'
import { Modal, Button } from '@mantine/core'
import classNames from 'classnames'
import Box from '@/components/ui/Box'
import { handlingLocations } from '@/lib/serviceCaseStatuses'


// Exclude "none" from selectable options
const selectableLocations = Object.entries(handlingLocations).filter(
    ([key]) => key !== 'none'
)

export default function ServiceCaseHandlingLocation({
    serviceCase,
    updateServiceCase,
}) {
    const { handling_location_config } = serviceCase
    const [opened, setOpened] = useState(false)
    const [selected, setSelected] = useState(null)
    const [selectedPickup, setSelectedPickup] = useState(false)
    const [loading, setLoading] = useState(false)

    const handleOpen = () => {
        setSelected(serviceCase.is_handled_by)
        setSelectedPickup(!!serviceCase.is_pickup_in_store)
        setOpened(true)
    }

    const handleSubmit = async () => {
        const locationChanged = selected !== serviceCase.is_handled_by
        const pickupChanged = selectedPickup !== !!serviceCase.is_pickup_in_store

        if (!locationChanged && !pickupChanged) {
            setOpened(false)
            return
        }

        setLoading(true)
        const patch = {}
        if (locationChanged) patch.is_handled_by = selected
        if (pickupChanged) patch.is_pickup_in_store = selectedPickup
        await updateServiceCase(patch)
        setLoading(false)
        setOpened(false)
    }

    return (
        <>
            <Box
                title="Lieu de traitement & récupération"
                globalAction={true}
                action={handleOpen}
                actionLabel="Modifier le lieu"
            >
                <div className="flex flex-col gap-1">
                    <span className={handling_location_config ? '' : 'text-gray-400'}>
                        {handling_location_config?.label || 'Non affecté'}
                    </span>
                    {serviceCase.is_pickup_in_store && (
                        <span className="text-xs text-blue-600">Le client récupérera la montre en boutique</span>
                    )}
                </div>
            </Box>

            <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                title="Lieu de traitement & récupération"
                centered
            >
                <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-2">
                        <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Lieu de traitement</p>
                        {selectableLocations.map(([key, { label }]) => (
                            <div
                                key={key}
                                className={classNames(
                                    'border rounded-xl p-3 cursor-pointer transition-colors',
                                    {
                                        'border-blue-500 bg-blue-50 text-blue-600':
                                            key === selected,
                                        'border-gray-200 hover:bg-gray-50':
                                            key !== selected,
                                    }
                                )}
                                onClick={() => setSelected(key)}
                            >
                                {label}
                            </div>
                        ))}
                    </div>

                    <div className="flex flex-col gap-2">
                        <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Récupération</p>
                        <div
                            className={classNames(
                                'border rounded-xl p-3 cursor-pointer transition-colors flex items-center gap-3',
                                {
                                    'border-blue-500 bg-blue-50 text-blue-600': selectedPickup,
                                    'border-gray-200 hover:bg-gray-50': !selectedPickup,
                                }
                            )}
                            onClick={() => setSelectedPickup(!selectedPickup)}
                        >
                            <span className={classNames(
                                'w-4 h-4 rounded-sm border flex items-center justify-center shrink-0 text-xs',
                                {
                                    'bg-blue-500 border-blue-500 text-white': selectedPickup,
                                    'border-gray-300': !selectedPickup,
                                }
                            )}>
                                {selectedPickup && '✓'}
                            </span>
                            Le client récupérera la montre en boutique
                        </div>
                    </div>

                    <Button
                        fullWidth
                        onClick={handleSubmit}
                        loading={loading}
                        disabled={!selected}
                    >
                        Enregistrer
                    </Button>
                </div>
            </Modal>
        </>
    )
}
